import pino from 'pino';
import {getAppParams} from '@zettant/commonUtils';

const env = getAppParams().env;
const logLevel = env === 'prod' ? 'info' : 'debug';

// TODO: Sentry等を使う場合には、appParameters.jsonから設定値を取得するようにする

const logger = pino({
  level: process.env.PINO_LOG_LEVEL || logLevel,
  formatters: {
    level: (label) => ({ level: label.toUpperCase() }),
  },
  timestamp: pino.stdTimeFunctions.isoTime,
});

export default logger;
